export default "__VITE_ASSET__CizXRrs8__"